import {
  CALLBACK_RESET,
  CALLBACK_SET,
  HISTORY_FILTER_CALLBACK_COUNT,
  LOGOUT,
  RESET_STATE,
  STORE_LOGIN,
  UPDATE_NORMAL_CALLBACK,
} from "../constants/action-types";

const initialState = {
  id: null,
  customer: null,
  self: null,
  remainings: null,
  conversationMedia: null,
  selfState: null,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case CALLBACK_SET:
      return {
        ...state,
        ...action.callback,
      };
    case UPDATE_NORMAL_CALLBACK:
      const connectedTime = new Date(
        action.callback.self?.connectedTime || ""
      ).getTime();
      return {
        ...state,
        ...action.callback,
        self: {
          ...action.callback.self,
          connectedTime,
        },
      };
    case HISTORY_FILTER_CALLBACK_COUNT:
      return {
        ...state,
        callbackCount: action.callbackCount,
      };
    case LOGOUT:
    case CALLBACK_RESET:
      return {
        ...initialState,
      };
    case STORE_LOGIN:
      return {
        ...action.payload.callback,
      };
    case RESET_STATE:
      return {};
    default:
      return state;
  }
};
